import type { ComponentType } from 'react';
import { Route, Routes } from 'react-router';
import { SiteFooter } from './components/footers/SiteFooter';
import { PublicHeader } from './components/headers/PublicHeader/PublicHeader';
import { PublicScrollbarGutter } from './components/PublicScrollbarGutter';
import { BrandSync } from './config/BrandSync';
import { AboutUs } from './pages/AboutUs';
import { LoginOrCreateAccountPage } from './pages/authentication/LoginOrCreateAccountPage';
import { ContactUs } from './pages/ContactUs';
import { Eula } from './pages/Eula';
import { FeaturesPage } from './pages/FeaturesPage';
import { LandingPage } from './pages/landing-page';
import { Organizations } from './pages/organizations/Organizations';
import { Privacy } from './pages/Privacy';
import { Providers } from './pages/providers/Providers';
import { Resources } from './pages/resources/Resources';
import { ScheduleA } from './pages/ScheduleA';
import { ScheduleB } from './pages/ScheduleB';
import { SecurityPage } from './pages/SecurityPage';
import { Terms } from './pages/Terms';
import { PUBLIC_SITE_PATHS, type PublicSitePath } from './routing/publicSiteRoutes';
import { ScrollToTop } from './routing/ScrollToTop';

const PUBLIC_SITE_COMPONENTS: Record<PublicSitePath, ComponentType> = {
  '/': LandingPage,
  '/about': AboutUs,
  '/contact': ContactUs,
  '/features': FeaturesPage,
  '/faq': Resources,
  '/resources': Resources,
  '/organizations': Organizations,
  '/privacy': Privacy,
  '/terms': Terms,
  '/eula': Eula,
  '/schedule-a': ScheduleA,
  '/schedule-b': ScheduleB,
  '/providers': Providers,
  '/security': SecurityPage,
  '/loginOrCreateAccount': LoginOrCreateAccountPage,
  '/signUp': LoginOrCreateAccountPage,
};

/**
 * Clerk-independent shell for routes that must remain available even when the
 * authentication service is unavailable or a satellite origin is misconfigured.
 */
export const PublicApp = () => (
  <div className="bg-base text-content-primary min-h-screen">
    <BrandSync />
    <PublicScrollbarGutter />
    <ScrollToTop />
    <div className="flex flex-col min-h-screen pt-20">
      <PublicHeader />
      <Routes>
        {PUBLIC_SITE_PATHS.map((path) => {
          const Component = PUBLIC_SITE_COMPONENTS[path];
          return <Route key={path} path={path} element={<Component />} />;
        })}
      </Routes>
      <SiteFooter />
    </div>
  </div>
);
